<template>
  <div class="w-full h-full">
    <file
      v-slot="{ url, type }"
      :file="discriminatedFile"
      :busy="loading"
      class="w-full h-full"
      styled
    >
      <medium v-if="url" :url="url" :type="type" />
    </file>
    <div class="close-icon" @click.stop="emit('remove')">
      <close-icon />
    </div>
    <transition name="fade">
      <Progress
        v-if="newFile && newFile.isNew && newFile.progress > 0 && newFile.progress < 100"
        :value="newFile.progress"
        class="progress"
      />
    </transition>
  </div>
</template>

<script lang="ts" setup>
import { computed, toRef, watch } from 'vue';
import CloseIcon from '@images/remove.svg?component';
import Progress from '@utils/Progress.vue';
import File from '@utils/File.vue';
import Medium from '@utils/Medium.vue';
import type { WbFile } from '@/entities/Entities';
import type { FileUpload } from './fileUpload';
import { useWbFile } from './wbFileUpload';

interface Props {
  file?: FileUpload<WbFile>;
  thumbnail?: boolean;
  thumbnailSize?: { width: number; height: number };
}

const props = defineProps<Props>();
const emit = defineEmits(['remove', 'file']);

const {
  file: discriminatedFile,
  newFile,
  loading,
} = useWbFile(
  computed(() => props.file),
  {
    thumbnail: toRef(props, 'thumbnail'),
    thumbnailSize: toRef(props, 'thumbnailSize'),
  },
);

watch(discriminatedFile, (newDiscriminatedFile) => {
  if (newDiscriminatedFile) {
    emit('file', newDiscriminatedFile);
  }
});
</script>

<style lang="scss" scoped>
.close-icon {
  // @apply rounded-full border-2 border-white;
  @apply absolute w-9 h-9 top-0 right-0 text-white;
  @apply cursor-pointer;

  stroke-width: px(4);
  padding: px(5);

  svg {
    @apply w-full h-full;
  }
}

.progress {
  @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2;
  @apply w-9/12;
}
</style>
